<template>
    
    <div class="main">
        <form-gerenciar></form-gerenciar>
    </div>
    
</template>
<script>

import formGerenciar from "./form"

export default {
    methods:{ },
    components:{ formGerenciar }
}
</script>
